import { useState, useCallback } from 'react';
import gamesService from '../services/gamesService';
import showToast from '../utils/toastUtils';
import { buildGameEnrichmentMaps } from '../utils/normalizers/auditTicketNormalizers';

export const useGamesData = () => {
  const [gamesData, setGamesData] = useState<any[]>([]);
  const [gamesMapState, setGamesMap] = useState<Map<string, number> | null>(null);

  const fetchGamesDataOnly = useCallback(async (stateId?: string): Promise<{ gamesResponse: any[] }> => {
    try {
      const gamesResponse = await gamesService.getAllGames(stateId);
      setGamesData(gamesResponse);
      return { gamesResponse: gamesResponse || [] };
    } catch (error) {
      console.error('Error fetching games data:', error);
      showToast.error('Failed to fetch games data. Using original data.');
      return { gamesResponse: [] };
    }
  }, []);

  const getGamesMap = useCallback((gamesResponse: any[]): Map<string, number> => {
    const { costByGameId } = buildGameEnrichmentMaps(gamesResponse, null);
    const gamesMapVar = new Map(costByGameId);
    setGamesMap(gamesMapVar);
    return gamesMapVar;
  }, []);

  return {
    gamesData,
    gamesMapState,
    fetchGamesDataOnly,
    getGamesMap,
  };
};
